import { FacebookIcon, InstagramIcon, LinkedinIcon, Mail, MapPin, Music2Icon, Phone, TwitterIcon } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (section) => (e) => {
    e.preventDefault();
    // Always navigate to home page first
    navigate('/');
    
    // If already on home page, scroll to section
    if (window.location.pathname === '/') {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section flex flex-col items-start justify-start">
            <div className="footer-brand">
              <div className="logo">
                <img src="/logos/AMC_White-8.png" alt="" />
              </div>
              <h3 className="text-xs sm:text-base">Africa Maritime Conference </h3>
            </div>
            <p className="text-xs sm:text-base">
              Empowering Africa's maritime Conference to drive global competitiveness and excellence through innovative
              training and sustainable workforce growth.
            </p>
            {/* SOCIAL LINKS */}
            <div className="flex justify-center gap-2">
              <a
                href="https://web.facebook.com/profile.php?id=61574941322459"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#1877F2] transition-transform transform hover:scale-110 text-xs sm:text-base"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://www.instagram.com/africamaritimeconference/?next=%2Fad_tools%2F"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#E4405F] transition-transform transform hover:scale-110 text-xs sm:text-base"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://x.com/AfricaMaritimeC"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#1DA1F2] transition-transform transform hover:scale-110 text-xs sm:text-base"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://www.linkedin.com/company/africa-maritime-conference/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#0077B5] transition-transform transform hover:scale-110 text-xs sm:text-base"
              >
                <LinkedinIcon />
              </a>
              <a
                href="https://www.tiktok.com/@africa.maritime.conf?_t=ZM-8wrXoIPEhIT&_r=1"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#EE1D52] transition-transform transform hover:scale-110 text-xs sm:text-base"
              >
                <Music2Icon />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="text-xs sm:text-base">Quick Links</h4>
            <ul className="flex flex-col gap-2 text-xs sm:text-base">
              <li>
                <Link to="/" className="hover:text-primary-orange transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:text-primary-orange transition-colors">About Us</Link>
              </li>
              <li className="w-full">
                <Link 
                  to="/" 
                  onClick={handleNavigation('speakers')}
                  className="inline-block w-full text-white hover:text-primary-orange transition-colors py-1"
                >
                  Speakers
                </Link>
              </li>
              <li className="w-full">
                <Link 
                  to="/"
                  onClick={handleNavigation('schedule')}
                  className="inline-block w-full text-white hover:text-primary-orange transition-colors py-1"
                >
                  Schedule
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="hover:text-primary-orange transition-colors">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="text-xs sm:text-base">Contact Info</h4>
            <div className="contact-info text-xs sm:text-base">
              <p className="flex gap-2 items-start">
                <MapPin /> Ethiopian Skylight Hotel
                <br />
                Addis Ababa, Ethiopia
              </p>
              <p className="flex gap-2 items-center">
                <Phone /> +251 970 317 022
              </p>
              <a href="mailto:info@africamaritimeconference.com" className="flex gap-2 items-center hover:text-primary-orange transition-colors">
                <Mail /> info@africamaritimeconference.com
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="text-xs sm:text-base">&copy; 2025 Africa Maritime Conference. All rights reserved.</p>
          <div className="footer-links text-xs sm:text-base">
            <Link to="/privacy-policy" className="hover:text-primary-orange transition-colors">Privacy Policy</Link>
            <a href="#" className="hover:text-primary-orange transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-primary-orange transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;